import { render } from "./ShowContact.vue?vue&type=template&id=21625df0"
import script from "./ShowContact.vue?vue&type=script&lang=js"
export * from "./ShowContact.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__